import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["sessions"];
import { LiveSessionCardDeprecated } from "../ui/LiveSessionCardDeprecated";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var PastSessions = function PastSessions(_ref) {
  var sessions = _ref.sessions,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sessions.length > 0 && /*#__PURE__*/_jsx("ol", {
      className: "tw-space-y-4",
      children: /*#__PURE__*/_jsx("div", {
        className: "tw-space-y-4 tw-rounded-[20px] tw-p-2.4 tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02",
        children: /*#__PURE__*/_jsx("ol", {
          className: "tw-space-y-1.6",
          children: sessions.map(function (session) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(LiveSessionCardDeprecated, _objectSpread({
                session: session
              }, otherProps))
            }, session.id);
          })
        })
      })
    })
  });
};